import React from "react";

const ShapeMobile4 = () => {
	return (
		<svg width={288} height={463} viewBox="0 0 288 463" fill="none">
			<g filter="url(#filter0_f_34_268)">
				<path
					d="M198.546 306.018C239.702 324.218 287.818 305.609 306.018 264.454C324.218 223.298 305.609 175.182 264.454 156.982C223.299 138.782 175.182 157.391 156.982 198.546C138.782 239.702 157.391 287.818 198.546 306.018Z"
					fill="url(#paint0_radial_34_268)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_34_268"
					x={0}
					y={0}
					width={463}
					height={463}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={75}
						result="effect1_foregroundBlur_34_268"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_34_268"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(389.597 331.245) rotate(-154.439) scale(376.554 341.937)"
				>
					<stop offset="0.34394" stopColor="#00EBFF" />
					<stop offset="0.619147" stopColor="#FF39B0" />
					<stop offset="0.974236" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default ShapeMobile4;
